<md-dialog>
	<div md-dialog-header>
		<md-icon icon="untitled-ui/general/check-done-02"></md-icon>
		<span class="md-text-lg-semibold">Confirm Attendance</span>
	</div>

	<div class="dialog-content">
		<p class="md-text-sm-regular">
			Please confirm the attendance for this lesson. This confirmation keeps an accurate record of absences and completed lessons and is required to
			process instructor payments and other internal workflows. Once you confirm, it cannot be undone.
		</p>

		<md-drop-down
			label="Attendance Status"
			placeholder="Select status"
			[options]="options()"
			[value]="selectedStatusID()"
			[disabled]="isLoading()"
			(change)="onStatusChange($event)"
		>
		</md-drop-down>

		@if (errorMessage()) {
			<div class="error-message">
				<md-icon icon="untitled-ui/alerts/alert-triangle"></md-icon>
				<span>{{ errorMessage() }}</span>
			</div>
		}

		@if (isAdmin()) {
			<label class="invoice-option">
				<input
					md-form-input
					type="checkbox"
					[checked]="generateInvoice()"
					(change)="generateInvoice.set($any($event.target).checked)"
					[disabled]="isLoading()"
				/>
				<span>Generate an invoice line item for this lesson, marking it for instructor payment in the current pay period.</span>
			</label>
		}
	</div>

	<div md-dialog-footer>
		<button md-button (click)="close()" [disabled]="isLoading()">Cancel</button>
		<button md-button-brand (click)="confirm()" [disabled]="!canConfirm()">
			@if (isLoading()) {
				<lb-loader size="small"></lb-loader>
			} @else {
				Confirm
			}
		</button>
	</div>
</md-dialog>
